import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/_blue_header/payer-acompte/legacy')({
  beforeLoad: ({ search }) => {
    throw redirect({ replace: true, search, to: '/payer-acompte/ancien' })
  },
  validateSearch: z.object({
    email: z.string().optional(),
    lastName: z.string().optional(),
    dossierNumber: z.string().optional(),
  }),
})
